export default function ImageCard({src, label}){
    return (
        <div className="transition transition-duration-500 hover-scaleX-1-1">
            <img src={src} className="object-fit-fill img-fluid border rounded-5" style={{width: "9rem", height: "9rem"}} alt={label}/>
            <div className="text-wrap text-word-break mt-2">{label}</div>
        </div>
    );
}